import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API, useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;

        if (!sessionId) {
            navigate("/logga-in", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await axios.post(
                    `${API}/auth/profile`,
                    {},
                    {
                        headers: { "X-Session-ID": sessionId },
                        withCredentials: true,
                    },
                );
                setUser(data.user);
                // Clean the URL fragment
                window.history.replaceState(
                    {},
                    document.title,
                    window.location.pathname,
                );
                const target =
                    data.user?.role === "admin" ? "/admin" : "/portal";
                navigate(target, { replace: true, state: { user: data.user } });
            } catch (e) {
                toast.error("Inloggningen misslyckades. Försök igen.");
                navigate("/logga-in", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen grid place-items-center bg-[#0A0A0B] text-[#F4F4F5]">
            <div className="flex flex-col items-center gap-4">
                <Loader2 size={28} className="animate-spin text-[#C4A977]" />
                <p className="text-[#A1A1AA] text-sm tracking-wide">
                    Loggar in...
                </p>
            </div>
        </div>
    );
}
